/**
 * achtBytes IoT API
 * The achtBytes IoT API handles all portal functionality.
 *
 * The version of the OpenAPI document: v1
 * Contact: info@achtbytes.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type AssetEventSeverity = 0 | 1 | 2 | 3;

export const AssetEventSeverity = {
    NUMBER_0: 0 as AssetEventSeverity,
    NUMBER_1: 1 as AssetEventSeverity,
    NUMBER_2: 2 as AssetEventSeverity,
    NUMBER_3: 3 as AssetEventSeverity
};

